export default __webpack_public_path__ + "static/media/landing.b00fa0ad.svg";